import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";

const ViewPopUp = ({ open, onCancel, reason }) => {
  return (
    <DiaglogBox width={617} open={open} onCancel={onCancel}>
      <div className="pb-5">
        <h4 className="pt-8 pb-4 w-full text-black text-[1.5625rem] font-bold text-center">
          Reason to Cancel Bid
        </h4>

        <hr />
        <p className="text-left font-bold text-[17px] px-11 py-3">Reason</p>
        <div className="px-11">
          <textarea
            className="border border-gray-300 p-2 focus:outline-none rounded-lg"
            style={{ width: "500px", height: "200px", resize: "none" }}
            readOnly
            value={reason || ""}
          />
        </div>
      </div>
    </DiaglogBox>
  );
};

export default ViewPopUp;
